// extracted by mini-css-extract-plugin
export default {"container":"user_container__0w9NY","content":"user_content__mN6jC"};